import { createContext } from "react";

const UsersExtensionsContext = createContext();
export default UsersExtensionsContext;
